import axios from 'axios';
import cookie from 'cookie';

import { ActionType, IChallengeImage } from 'interfaces';
import { MediaObjectType } from 'interfaces/mediaObject.types';
import { AUTH_COOKIE_KEY } from 'utils/useAuthToken';
import { ROUTES } from '../constants';

export const API_ROOT =
  process.env.NODE_ENV === 'production'
    ? `${window.location.protocol}//${window.location.host}`
    : process.env.REACT_APP_HOST;

axios.defaults.withCredentials = true;

export const api = axios.create({
  baseURL: `${API_ROOT}/v2`,
  timeout: 0,
  headers: {
    'content-type': 'application/ld+json',
  },
});

export const REQUEST = 'REQUEST';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';

export interface RequestTypes {
  REQUEST: string;
  SUCCESS: string;
  FAILURE: string;
}

export const createRequestTypes = (base: string): RequestTypes => ({
  REQUEST: `${base}_${REQUEST}`,
  SUCCESS: `${base}_${SUCCESS}`,
  FAILURE: `${base}_${FAILURE}`,
});

export const action = (type: string, payload = {}): ActionType => ({
  type,
  payload,
});

export const formatApiURI = (partialURI: string) =>
  `${API_ROOT}/v2/${partialURI}`;

/**
 * TODO: media utils has been created with getMediaObjectURI copy,
 * remove this one and fix all components
 */
export const getMediaObjectURI = (
  partialUri:
    | string
    | number
    | MediaObjectType
    | IChallengeImage
    | undefined
    | null,
): string => {
  if (!partialUri) {
    console.warn('No parameter received for getMediaObjectURI'); // eslint-disable-line no-console
    return '';
  }
  if (typeof partialUri === 'number' || !isNaN(Number(partialUri))) {
    // eslint-disable-line no-restricted-globals
    return `${API_ROOT}/v2/media-objects/${partialUri}`;
  }
  if (typeof partialUri === 'string') {
    if (partialUri.indexOf('/v2/media-objects/') === 0) {
      return `${API_ROOT}${partialUri}`;
    }
    return `${API_ROOT}/v2/media-objects/${partialUri}`;
  }
  if (partialUri['@id']) {
    return `${API_ROOT}${partialUri['@id']}`;
  }
  if (partialUri.id) {
    return `${API_ROOT}/v2/media-objects/${partialUri.id}`;
  }

  console.error(
    // eslint-disable-line no-console
    'The received parameter for getMediaObjectURI does not have the expected format:',
    `"${partialUri}"`,
    'Expected either a string or a number or a MediaObjectType',
  );
  return '';
};

export const setAuthToken = (token?: string): void => {
  if (token) {
    api.defaults.headers.common.Authorization = `${AUTH_COOKIE_KEY} ${token}`;
  } else {
    delete api.defaults.headers.common.Authorization;
  }
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      document.cookie = cookie.serialize(AUTH_COOKIE_KEY, '', {
        path: ROUTES.HOME,
      });
      setAuthToken();
      const redirectPathname = `${ROUTES.BASENAME}${ROUTES.LOGIN}`;
      if (window.location.pathname !== redirectPathname) {
        window.location.replace(redirectPathname);
      }
    }
    return Promise.reject(error);
  },
);
